import React from 'react';
import { useController } from 'react-hook-form';

import styled from 'styled-components';

type Props = {
  id: string;
  name?: string;
  onChange?: (e: any) => void;
  label?: string | JSX.Element;
  checked: boolean;
  unactive?: boolean;
  placement?: 'left' | 'right';
  align?: 'start' | 'center' | 'end';
};

export const Checkbox = ({
  id,
  name,
  onChange,
  label,
  checked,
  unactive = false,
  placement = 'right',
  align = 'start',
}: Props): JSX.Element => {
  const controller = !name ? null : useController({ name });

  return (
    <Container align={align}>
      {placement === 'left' && (
        <InputLabel placement="left">{label}</InputLabel>
      )}
      <HiddenCheckbox
        {...controller?.field}
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={unactive}
      />
      <CustomCheckbox htmlFor={id} $unactive={unactive} />
      {placement === 'right' && (
        <InputLabel placement="right">{label}</InputLabel>
      )}
    </Container>
  );
};

const Container = styled.div<{ align: string }>`
  display: flex;
  justify-content: ${({ align }) => align};
  vertical-align: middle;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  visibility: hidden;
  &:disabled {
    cursor: not-allowed;
  }
`;

const CustomCheckbox = styled.label<{ $unactive: boolean }>`
  display: inline-block;
  position: relative;
  height: 1.5em;
  width: 1.5em;
  background: transparent;
  border-radius: 8px;
  border: 1px solid #aabb00;
  transition: 0.3s all ease;
  cursor: ${({ $unactive }) => ($unactive ? 'default' : 'pointer')};

  &:after {
    content: '';
    position: absolute;
    border: solid white;
    border-width: 0 0.15em 0.15em 0;
    transform: rotate(45deg);
    width: 0.4em;
    height: 0.8em;
    left: 0.5em;
    top: 0.2em;
    opacity: 0;
    transition: 0.2s ease;
  }

  ${HiddenCheckbox}:checked + & {
    background: #154077;
    &:after {
      opacity: 1;
    }
  }
`;

const InputLabel = styled.label<{ placement: string }>`
  font-weight: 600;
  color: #154077;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.5rem;
  margin-right: ${({ placement }) => placement == 'left' && '0.5rem'};
  margin-left: ${({ placement }) => placement == 'right' && '0.5rem'};
  & > div > a {
    font-style: italic;
    text-decoration: underline;
  }
`;
